import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuizEntryEdit;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { DragSource } from 'react-dnd';
import pick from 'lodash/pick';
import first from 'lodash/first';
import { jsx, Global } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import CustomPropTypes from '../../../../../common/util/CustomPropTypes';
import AddToBankModal from '../../../../../banks/components/AddToBankModal';
import DragAndDropZone from '../../../../../common/components/shared/drag_and_drop/DragAndDropZone';
import wrapWithOutsideClickEmotion from '../../../../../common/components/shared/functionality/componentWithOutsideClickEmotion';
import { checkClickedNode } from '../../../../../common/util/clickHandlers';
import QuizEntryEditHeader from './Header';
import QuizEntryEditFooter from './Footer';
import { SHOULD_CLONE_ITEM, TEMPORARY_ITEM_ID, DELETED_QUIZ_ENTRY, API_INPUT_VALIDATION_ERROR, CLEAR_ALL_INPUT_VALIDATION_ERRORS, PARENT_TYPE_ADDING_TO_BANK, withStyleOverrides } from '@instructure/quiz-common';
import { ItemTypes, dragSource, collectDrag } from '../../../../../common/components/shared/drag_and_drop/dragAndDropUtils';
import generateStyle from './styles';
import generateComponentTheme from './theme';
var QuizEntryEdit = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuizEntryEdit = /*#__PURE__*/function (_Component) {
  function QuizEntryEdit() {
    var _this2;
    _classCallCheck(this, QuizEntryEdit);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, QuizEntryEdit, [].concat(args));
    _defineProperty(_this2, "state", {
      canSubmit: true
    });
    _defineProperty(_this2, "onSubmit", function (e) {
      var displayPosition = _this2.props.displayPosition;
      e && e.preventDefault();
      if (_this2.isValid() && _this2.state.canSubmit) {
        _this2.successfulSubmit();
      } else {
        var msg = t('Item {displayPosition, number} cannot be saved due to invalid input data.', {
          displayPosition: displayPosition
        });
        _this2.props.screenreaderNotification(msg);
        _this2.props.showError(_this2.props.guid);
        _this2.props.clearNextQuizEntry();
      }
    });
    _defineProperty(_this2, "createOrUpdateItem", function () {
      var workingEntry = _this2.props.workingEntry;
      if (_this2.props.entry.isTemporary()) {
        return _this2.props.createItem(workingEntry, _this2.props.quizId, 'quiz');
      } else if (_this2.props.shouldClone) {
        return _this2.props.createItem(workingEntry, _this2.props.quizId, 'quiz', workingEntry.id);
      } else if (_this2.props.entry.hasModifications()) {
        return _this2.props.updateItem(workingEntry, _this2.props.quizId, 'quiz');
      }
      return Promise.resolve(_this2.props.entry.toJS());
    });
    _defineProperty(_this2, "createNextQuizEntry", function () {
      var _this2$props$nextQuiz = _this2.props.nextQuizEntry,
        interactionTypeData = _this2$props$nextQuiz.interactionTypeData,
        quizId = _this2$props$nextQuiz.quizId,
        position = _this2$props$nextQuiz.position,
        stimulusId = _this2$props$nextQuiz.stimulusId,
        parentEntryId = _this2$props$nextQuiz.parentEntryId;
      if (!interactionTypeData) {
        _this2.props.createTempStimulus(quizId, position);
      } else {
        var defaultInteractionData = interactionTypeData.getDefaultInteractionData();
        var scoringData = interactionTypeData.getDefaultScoringData(defaultInteractionData);
        _this2.props.createTempItem(quizId, position, {
          id: interactionTypeData.id,
          interactionData: defaultInteractionData,
          itemBody: interactionTypeData.itemBody,
          properties: interactionTypeData.defaultProperties,
          scoringAlgorithm: interactionTypeData.scoringAlgorithmDefault,
          scoringData: scoringData,
          userResponseType: first(interactionTypeData.userResponseTypeOptions)
        }, parentEntryId, stimulusId);
      }
      _this2.props.clearNextQuizEntry();
    });
    _defineProperty(_this2, "createOrUpdateQuizEntry", function (itemData) {
      var _this2$props = _this2.props,
        workingEntry = _this2$props.workingEntry,
        workingQuizEntry = _this2$props.workingQuizEntry,
        quizEntry = _this2$props.quizEntry,
        shouldClone = _this2$props.shouldClone;
      if (workingQuizEntry.isTemporary) {
        return _this2.props.createQuizEntry(_this2.props.quizId, workingEntry.id === TEMPORARY_ITEM_ID ? itemData.id : workingEntry.id, workingQuizEntry.entryType, workingQuizEntry.getProperties(), !_this2.props.addContentPopoverOpen);
      } else if (shouldClone && (!quizEntry.isBankEntry || quizEntry.isArchivedBankEntry)) {
        return _this2.props.cloneQuizEntry(_this2.props.quizId, workingQuizEntry.id, Object.assign({}, workingQuizEntry.toJS(), {
          entryId: itemData.id,
          entryType: quizEntry.isArchivedBankEntry ? quizEntry.getEntry().entryType : quizEntry.entryType
        }));
      } else if (_this2.props.quizEntry.hasModifications()) {
        // if a quiz entry is a bank entry, item.id is not bank entry id
        // if a quiz entry is not a bank entry, item.id is entry id
        var entryId = quizEntry.isBankEntry ? workingQuizEntry.entry.get('id') : itemData.id;
        return _this2.props.updateQuizEntry(_this2.props.quizId, workingQuizEntry.id, Object.assign({}, workingQuizEntry.toJS(), {
          entryId: entryId
        }));
      }
      return Promise.resolve(_this2.props.quizEntry);
    });
    _defineProperty(_this2, "handleApiErrors", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(fetcherError) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!fetcherError.validationErrorsFromApi) {
                _context.next = 4;
                break;
              }
              _this2.props.handleValidationErrorsFromApi(fetcherError.validationErrorsFromApi);
              _context.next = 5;
              break;
            case 4:
              throw fetcherError;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this2, "successfulSubmit", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var itemData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this2.setState({
              canSubmit: false
            });
            _context2.prev = 1;
            _context2.next = 4;
            return _this2.createOrUpdateItem();
          case 4:
            itemData = _context2.sent;
            _context2.next = 7;
            return _this2.createOrUpdateQuizEntry(itemData);
          case 7:
            _context2.next = 14;
            break;
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            _this2.setState({
              canSubmit: true
            });
            _this2.handleApiErrors(_context2.t0);
            // When reached, this is always a validation error
            return _context2.abrupt("return", API_INPUT_VALIDATION_ERROR);
          case 14:
            _this2.props.hideError(_this2.props.guid);
            if (_this2.props.shouldClone) {
              _this2.props.openRegradeModal();
            }
            _this2.clearModifications();
            if (_this2.props.nextQuizEntry) {
              _this2.createNextQuizEntry();
            }
            // Delay the switchOffEditing call to prevents the focus from incorrectly
            // jumping back to the previous question during the transition between questions.
            setTimeout(function () {
              _this2.props.switchOffEditing();
            });
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 9]]);
    })));
    _defineProperty(_this2, "clearChanges", function () {
      var fromCancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _this2.props.clearValidationErrorsFromApi(CLEAR_ALL_INPUT_VALIDATION_ERRORS);
      _this2.clearModifications();
      if (_this2.props.quizEntry.isTemporary) {
        _this2.props.clearTemporaryItem(_this2.props.quizId);
        if (fromCancel) {
          _this2.props.setUi(DELETED_QUIZ_ENTRY, {
            position: Math.ceil(_this2.props.quizEntry.position),
            inStimulus: _this2.props.quizEntry.hasStimulus
          });
        }
      }
    });
    _defineProperty(_this2, "handleAddToBankContinue", function () {
      if (_this2.props.workingQuizEntry.isTemporary) {
        _this2.setState({
          canSubmit: false
        });
      }
    });
    _defineProperty(_this2, "handleAddToBank", function (bankEntry) {
      var workingQuizEntry = _this2.props.workingQuizEntry;
      if (workingQuizEntry.isTemporary) {
        _this2.props.createQuizEntry(_this2.props.quizId, bankEntry.id, 'BankEntry', workingQuizEntry.getProperties());
        _this2.props.clearTemporaryItem(_this2.props.quizId);
        _this2.clearModifications();
        _this2.props.switchOffEditing();
      } else if (_this2.props.shouldClone) {
        _this2.props.cloneQuizEntry(_this2.props.quizId, workingQuizEntry.id, Object.assign({}, workingQuizEntry.toJS(), {
          entryId: bankEntry.id,
          entryType: 'BankEntry'
        }));
      } else {
        _this2.props.updateQuizEntry(_this2.props.quizId, workingQuizEntry.id, {
          entryId: bankEntry.id,
          entryType: 'BankEntry'
        });
      }
    });
    _defineProperty(_this2, "getEntryForBank", function () {
      var _this2$props2 = _this2.props,
        entry = _this2$props2.entry,
        workingEntry = _this2$props2.workingEntry,
        quizId = _this2$props2.quizId,
        shouldClone = _this2$props2.shouldClone;
      if (entry.isTemporary()) {
        return _this2.props.createItem(workingEntry, quizId, PARENT_TYPE_ADDING_TO_BANK);
      } else if (entry.hasModifications()) {
        if (shouldClone) {
          return _this2.props.createItem(workingEntry, quizId);
        } else {
          return _this2.props.updateItem(workingEntry, quizId);
        }
      } else {
        return Promise.resolve(entry);
      }
    });
    _defineProperty(_this2, "connectDragSource", function (dragHandle) {
      return _this2.props.connectDragSource(dragHandle);
    });
    _defineProperty(_this2, "clearModifications", function () {
      _this2.props.clearModifications('items', _this2.props.entry.id);
      _this2.props.clearModifications('quizEntries', _this2.props.quizEntry.id);
    });
    _defineProperty(_this2, "shouldDisableSubmit", function () {
      return Boolean(!_this2.state.canSubmit || _this2.props.haveValidationErrorsFromApi);
    });
    _defineProperty(_this2, "renderDraggable", function () {
      var _this2$props3 = _this2.props,
        connectDragPreview = _this2$props3.connectDragPreview,
        draggingOver = _this2$props3.draggingOver,
        draggingAboveHalf = _this2$props3.draggingAboveHalf;
      var propsForDnDZone = {
        draggingOver: draggingOver,
        draggingAboveHalf: draggingAboveHalf
      };
      return jsx("div", null, jsx(DragAndDropZone, Object.assign({}, propsForDnDZone, {
        location: "above"
      })), connectDragPreview(_this2.renderForm()), jsx(DragAndDropZone, Object.assign({}, propsForDnDZone, {
        location: "below"
      })));
    });
    return _this2;
  }
  _inherits(QuizEntryEdit, _Component);
  return _createClass(QuizEntryEdit, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onEditQuizEntryToggle(this.props.quizEntry.id);
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.setUi(SHOULD_CLONE_ITEM, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setUi(SHOULD_CLONE_ITEM, false);
    }
  }, {
    key: "clickedOutside",
    value: function clickedOutside() {
      this.onSubmit();
    }
  }, {
    key: "ignoreClickOutsideIf",
    value: function ignoreClickOutsideIf(e) {
      var _checkClickedNode = checkClickedNode(e, this.props.appContainer),
        isEndEditingTrigger = _checkClickedNode.isEndEditingTrigger,
        outsideApp = _checkClickedNode.outsideApp;
      return this.props.isOccluded || outsideApp || !isEndEditingTrigger;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return this.props.workingEntry.isValid() && this.props.workingQuizEntry.isValid();
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var isItemOrBankEntry = this.props.quizEntry.isItem || this.props.quizEntry.isBankEntry;
      if (!(isItemOrBankEntry || this.props.disabledForRegrade)) return;
      var footerProps = pick(this.props, ['alternativeRightFooter', 'changeQuizEntryPoints', 'clearTemporaryItem', 'displayPosition', 'entry', 'guid', 'initialFocusId', 'itemEditArea', 'openModal', 'quizEntry', 'setUi', 'shouldClone', 'workingQuizEntry']);
      return jsx(QuizEntryEditFooter, Object.assign({
        clearChanges: this.clearChanges,
        isValid: this.isValid(),
        successfulSubmit: this.successfulSubmit,
        disableSubmit: this.shouldDisableSubmit()
      }, footerProps));
    }
  }, {
    key: "renderAddToBankModal",
    value: function renderAddToBankModal() {
      if (!this.props.quizEntry.isItem) return;
      return jsx(AddToBankModal, {
        label: t('Add to an Item Bank'),
        onContinue: this.handleAddToBankContinue,
        onAdd: this.handleAddToBank,
        getEntry: this.getEntryForBank,
        entryId: this.props.guid,
        entryType: this.props.quizEntry.entryType,
        quizId: this.props.quizId,
        handleValidationErrorsFromApi: this.props.handleValidationErrorsFromApi
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var headerProps = pick(this.props, ['changeItemTitle', 'clearModifications', 'clearTemporaryItem', 'connectDragSource', 'createTempItem', 'disabledForRegrade', 'displayPosition', 'entry', 'guid', 'hideError', 'initialFocusId', 'name', 'newActiveBank', 'quizEntries', 'quizEntry', 'quizId', 'removeQuizEntry', 'richFITBEnabled', 'richFITBInteractionID', 'screenreaderNotification', 'setUi', 'shouldClone', 'showError', 'withConfirm', 'workingEntry', 'workingQuizEntry']);
      return jsx(QuizEntryEditHeader, Object.assign({
        isValid: this.isValid(),
        successfulSubmit: this.successfulSubmit,
        disableSubmit: this.shouldDisableSubmit()
      }, headerProps));
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      return jsx("div", null, jsx("div", {
        css: this.props.styles.quizEntryEdit,
        "data-automation": "sdk-quiz-entry-edit-div"
      }, jsx("div", {
        role: "form"
      }, this.renderHeader(), this.props.children, this.renderFooter()), this.renderAddToBankModal()));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(React.Fragment, null, jsx(Global, {
        styles: this.props.styles.globalStyles
      }), this.props.disabledForRegrade ? this.renderForm() : this.renderDraggable());
    }
  }]);
}(Component), _defineProperty(_QuizEntryEdit, "displayName", 'QuizEntryEdit'), _defineProperty(_QuizEntryEdit, "componentId", "Quizzes".concat(_QuizEntryEdit.displayName)), _defineProperty(_QuizEntryEdit, "propTypes", {
  addContentPopoverOpen: PropTypes.bool.isRequired,
  alternativeRightFooter: PropTypes.func,
  appContainer: CustomPropTypes.selectors.isRequired,
  changeItemTitle: PropTypes.func.isRequired,
  // from connected component
  changeQuizEntryPoints: PropTypes.func.isRequired,
  // from connected component
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  clearModifications: PropTypes.func.isRequired,
  // from connected component
  clearNextQuizEntry: PropTypes.func.isRequired,
  // from connected component
  clearTemporaryItem: PropTypes.func.isRequired,
  // from connected component
  cloneQuizEntry: PropTypes.func.isRequired,
  // from connected component
  clearValidationErrorsFromApi: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  // inserted from React DnD
  connectDragSource: PropTypes.func.isRequired,
  // inserted from React DnD
  createItem: PropTypes.func.isRequired,
  // from connected component
  createTempItem: PropTypes.func.isRequired,
  // from connected component
  createTempStimulus: PropTypes.func.isRequired,
  // from connected component
  createQuizEntry: PropTypes.func.isRequired,
  // from connected component
  disabledForRegrade: PropTypes.bool,
  displayPosition: PropTypes.number.isRequired,
  draggingAboveHalf: PropTypes.bool.isRequired,
  draggingOver: PropTypes.bool.isRequired,
  entry: ImmutablePropTypes.record.isRequired,
  guid: PropTypes.string.isRequired,
  handleValidationErrorsFromApi: PropTypes.func.isRequired,
  haveValidationErrorsFromApi: PropTypes.bool,
  hideError: PropTypes.func.isRequired,
  // from connected component
  initialFocusId: PropTypes.string,
  isOccluded: PropTypes.bool,
  itemEditArea: PropTypes.object,
  name: PropTypes.string,
  newActiveBank: PropTypes.func,
  nextQuizEntry: ImmutablePropTypes.map,
  openRegradeModal: PropTypes.func.isRequired,
  quizEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  onEditQuizEntryToggle: PropTypes.func,
  openModal: PropTypes.func.isRequired,
  quizEntry: ImmutablePropTypes.record.isRequired,
  quizId: PropTypes.string.isRequired,
  removeQuizEntry: PropTypes.func.isRequired,
  // from connected component
  richFITBEnabled: PropTypes.bool,
  richFITBInteractionID: PropTypes.string,
  screenreaderNotification: PropTypes.func.isRequired,
  // from connected component
  setUi: PropTypes.func.isRequired,
  shouldClone: PropTypes.bool,
  showError: PropTypes.func.isRequired,
  // from connected component
  switchOffEditing: PropTypes.func.isRequired,
  updateQuizEntry: PropTypes.func.isRequired,
  // from connected component
  updateItem: PropTypes.func.isRequired,
  // from connected component
  withConfirm: PropTypes.func.isRequired,
  workingEntry: ImmutablePropTypes.record.isRequired,
  workingQuizEntry: ImmutablePropTypes.record.isRequired,
  styles: PropTypes.object
}), _defineProperty(_QuizEntryEdit, "defaultProps", {
  alternativeRightFooter: null,
  children: null,
  disabledForRegrade: false,
  haveValidationErrorsFromApi: false,
  initialFocusId: null,
  isOccluded: false,
  itemEditArea: null,
  name: null,
  nextQuizEntry: null,
  newActiveBank: null,
  onEditQuizEntryToggle: Function.prototype,
  richFITBEnabled: false,
  richFITBInteractionID: '',
  shouldClone: false
}), _QuizEntryEdit)) || _class);
export var UndecoratedQuizEntryEdit = QuizEntryEdit;
export var QuizEntryEditRaw = wrapWithOutsideClickEmotion(QuizEntryEdit);
export default DragSource(ItemTypes.QUIZ_ENTRY, dragSource, collectDrag)(QuizEntryEditRaw);